import "./CommercialScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import Overview from "./sections/Overview";
import Contractors from "./sections/Contractors";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function CommercialScaffoldingPage() {
  return <div>
      <Header />
      <Overview />
      <Contractors />
      <Quote />
      <Footer />
    </div>;
}